import React, { useState, useEffect } from "react";
import profile from "./assets/preston.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin,
  faStackOverflow,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { Brightness4, Brightness7 } from "@material-ui/icons";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { IconButton } from "@material-ui/core";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div
      className={`flex flex-col items-center h-screen ${
        isDarkMode ? "bg-gray-900 text-white" : "bg-white text-black"
      }`}
    >
      <div className="absolute top-4 right-4">
        <IconButton onClick={toggleTheme}>
          {isDarkMode ? <Brightness7 /> : <Brightness4 />}
        </IconButton>
      </div>
      <div className="flex-grow overflow-auto">
        <div className="flex flex-col sm:flex-row items-center p-6 sm:p-2">
          <div>
            <img
              src={profile}
              width={400}
              height={400}
              alt="Profile"
              className="rounded-full"
            />
          </div>
          <div className="sm:flex-grow sm:text-left text-center">
            <p className="text-3xl font-bold">Preston Osoro</p>
            <p className="text-1xl font-medium text-slate-500">
              Software Craftsman
            </p>
          </div>
        </div>
        <div className="flex justify-center">
          <div className="social-icons flex flex-wrap items-center justify-center">
            <a
              href="https://github.com/Preston-56"
              target="_blank"
              rel="noopener noreferrer"
              className="m-2"
            >
              <FontAwesomeIcon icon={faGithub} size="2x" />
            </a>
            {/* <a
              href="https://x.com/prestonosoro"
              target="_blank"
              rel="noopener noreferrer"
              className="m-2"
            >
              <i className="fa-brands fa-square-x-twitter fa-2x"></i>
            </a> */}
            <a
              href="https://www.linkedin.com/in/preston-osoro/"
              target="_blank"
              rel="noopener noreferrer"
              className="m-2 text-blue-700"
            >
              <FontAwesomeIcon icon={faLinkedin} size="2x" />
            </a>
            <a
              href="https://stackoverflow.com/users/18075679/preston-osoro"
              target="_blank"
              rel="noopener noreferrer"
              className="m-2 text-orange-500"
            >
              <FontAwesomeIcon icon={faStackOverflow} size="2x" />
            </a>
            <a
              href="https://preston-56.hashnode.dev/"
              target="_blank"
              rel="noopener noreferrer"
              className="m-2 text-blue-600"
            >
              <i className="fa-brands fa-hashnode fa-2x"></i>
            </a>
            <a
              href="mailto:prestonosoro56@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="m-2"
            >
              <FontAwesomeIcon icon={faEnvelope} size="2x" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
